import { SOURCE_PLATFORM_TYPE } from '@/entities/public-filter/constants';
import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

import {
  paginationRequestSchema,
  paginationResponseSchema,
  type PaginationResponse,
} from '@/shared/schema/pagination';
import { campaignDetailCreatorSchema } from '../schema';
import type { CampaignDetailCreator } from '../type';

export const fetchCampaignCreatorsRequestSchema = z.object({
  platform: z.enum(SOURCE_PLATFORM_TYPE).optional(),
  label: z.string().trim().min(1).optional(),
  name: z.string().trim().min(1).optional(),
  ...paginationRequestSchema.shape,
});

export const campaignCreatorsResponseSchema = z.object({
  items: z.array(campaignDetailCreatorSchema),
  pagination: paginationResponseSchema,
});

export type FetchCampaignCreatorsRequest = Partial<
  z.input<typeof fetchCampaignCreatorsRequestSchema>
>;

export async function FetchCampaignCreators(
  campaignId: string,
  pending: boolean,
  request?: FetchCampaignCreatorsRequest,
  signal?: AbortSignal,
): Promise<{
  items: Array<CampaignDetailCreator>;
  pagination: PaginationResponse;
}> {
  const parsedRequest = fetchCampaignCreatorsRequestSchema.parse(request ?? {});
  let response;
  if (!pending) {
    response = await socialApiClient.get(`campaigns/${campaignId}/creators`, {
      searchParams: parsedRequest,
      signal,
    });
  } else {
    response = await socialApiClient.get(`campaigns/${campaignId}/pending_creators`, {
      searchParams: parsedRequest,
      signal,
    });
  }

  return campaignCreatorsResponseSchema.parse(await response.json());
}
